















































import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import ModifiedDataHandler from '@/mixins/ModifiedDataHandler'
import FooterFixedHandler from '@/mixins/FooterFixedHandler'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import {Form, FormItem} from 'element-ui'
import FloatingLabelInput from '@/components/FloatingLabelInput.vue'
import {isMobilePhone} from 'validator'
import {mask} from 'vue-the-mask'
import {UpdateClientContactPayload} from '@/store/modules/clients/types'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {namespace} from 'vuex-class'

const clients = namespace('clients')
const layout = namespace('layout')
const issue = namespace('issue')
const gtm = namespace('gtm')

@Component({
  components: {
    [Form.name]: Form, [FormItem.name]: FormItem, FloatingLabelInput,
    MainLayout, HeaderLayout, FooterLayout, FooterButton, TitleAndMessage
  },
  directives: {mask},
})
export default class IssueSetClientContact extends Mixins(Translation, ModifiedDataHandler, FooterFixedHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: false, type: Boolean}) isConfirm: boolean

  @Ref('formRef') readonly formRef!: Form

  @clients.Action('updateClientContact') updateClientContact: (payload: UpdateClientContactPayload) => Promise<void>
  @clients.Action('getClient') getClient: (payload: {clientId: string}) => Promise<void>
  @layout.Mutation('updateError') updateError: (payload: object) => void
  @issue.State('clientId') clientId: string
  @issue.Getter('gtmCommonInfo') gtmCommonInfo: object
  @issue.Mutation('update') updateIssue: (payload: object) => void
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  phoneNumber: string | null = ''
  email: string | null  = ''
  emailSub: string | null  = ''

  loading: boolean = true
  visibleEmailSub: boolean = false

  @Watch('emailSub')
  __emailSub(value) {
    if(value) {
      this.visibleEmailSub = true
    }
  }

  @Watch('formModel', {deep: true})
  __formModel(value) {
    this.modifiedData = this.diffData(this.originalData, value)
  }


  get message() {
    const {ts} = this
    return {
      title: [`${ts('client')}에`, `${ts('alarm')}을 보낼까요?`],
    }
  }

  get formModel(): any {
    return {
      phoneNumber: this.phoneNumber,
      email: this.email,
      emailSub: this.emailSub,
    }
  }

  get rules(): object {
    const {ts} = this
    return {
      phoneNumber: [
        {
          type: 'string',
          validator: (_, value, callback) => {
            if(value && !isMobilePhone(value, 'ko-KR')) {
              return callback(new Error(`${ts('phone-number')}형식에 맞게 ${ts('input')}해주세요`))
            }
            return callback()
          },
          trigger: ['change', 'blur'],
        }
      ],
      email: [
        {
          type: 'email',
          message: `${ts('email')} 형식에 맞게 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ],
      emailSub: [
        {
          type: 'email',
          message: `${ts('email')} 형식에 맞게 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ],
    }
  }

  onClickBackward() {
    if(this.isModifiedData) {
      const {message, options} = this.confirmMessageOptions
      this.$confirm(message, options)
        .then(() => {
          this.setContact(this.originalData)
        })
        .then(() => {
          this.$emit('action', 'back')
        })
        .catch((e) => e)
    } else {
      this.$emit('action', 'back')
    }
  }

  updateClient() {
    const updateData = {
      ...this.formModel,
      id: this.clientId
    }
    return this.updateClientContact(updateData)
      .then((response: any) => {
        return this.updateIssue({clientId: response?.id})
      })
      .catch((error) => {
        this.updateError({
          id: 'update-client-contact',
          message: `${this.ts('client')} ${this.ts('contact')}를 수정 하는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
  }

  onClickNext() {
    this.formRef.validate((valid) => {
      if(valid) {
        this.updateClient()
          .then(() => {this.$emit('action', 'ok')})
          .then(() => {
            if(!this.isConfirm) {
              const emailList = ['email', 'emailSub'].filter((item) => (this[item]))
              if(!this.isConfirm) {
                this.logEventWithGroups({
                  eventType: 'input_client_contact',
                  eventProperties: {
                    ...this.gtmCommonInfo,
                    'email_count': emailList.length,
                    'phone_number_count': this.phoneNumber ? 1 : 0,
                  }
                })
              }
            }
          })
      }
    })
  }

  showEmailSub(visible) {
    this.visibleEmailSub = visible
    if(!this.visibleEmailSub) {
      this.emailSub = ''
    }
  }

  setContact(data) {
    this.email = data.email
    this.emailSub = data.emailSub
    this.phoneNumber = data.phoneNumber
  }

  loadClient() {
    this.getClient({clientId: this.clientId})
      .then((response: any) => {
        this.setContact(response)
        this.setOriginalData(this.formModel)
      })
      .catch((error) => {
        this.updateError({
          id: 'get-client',
          message: `${this.ts('client')} 정보를 불러오는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {
        this.loading = false
      })
  }

  created() {
    if(this.clientId) {
      this.loadClient()
    } else {
      this.loading = false
      this.updateError({
        id: 'get-client',
        message: `${this.ts('client')} 정보를 불러오는데 ${this.ts('failed')}하였습니다.`,
      })
    }
  }

  beforeDestroy() {
    if(this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'confirm_client_contact',
        eventProperties: {
          ...this.gtmCommonInfo,
          modified: this.isModifiedData,
        }
      })
    }
  }
}
